import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { lastValueFrom } from 'rxjs';
import { DutyEngineer } from 'icreate/common/models/duty-engineer';
import { DutyEngineerEvents } from 'icreate/common/io-event/websocket-message';
import { SocketMiddlewareService } from './socket-middleware.service';

@Injectable({
    providedIn: 'root',
})
export class DutyEngineerService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        private http: HttpClient,
        private socketService: SocketMiddlewareService
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(vesselId: string) {
        return await lastValueFrom(
            this.http.get<DutyEngineer[]>(`${this.domain}/api/dutyEngineer`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getBySlotId(slotId: string) {
        return await lastValueFrom(
            this.http.get<DutyEngineer[]>(`${this.domain}/api/dutyEngineer/${slotId}`, {
                headers: this.headers,
            })
        );
    }

    async create(data: DutyEngineer) {
        return await lastValueFrom(
            this.http.post<DutyEngineer>(`${this.domain}/api/dutyEngineer`, data, {
                headers: this.headers,
            })
        );
    }

    async update(id: string, data: DutyEngineer) {
        return await lastValueFrom(
            this.http.put<DutyEngineer>(`${this.domain}/api/dutyEngineer/${id}`, data, {
                headers: this.headers,
            })
        );
    }

    async deleteEngineer(id: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/dutyEngineer/${id}`, {
                headers: this.headers,
            })
        );
    }

    async reorderList(settingsId: string, orderedIds: string[]) {
        return lastValueFrom(
            this.http.put(
                `${this.domain}/api/dutyEngineer/reorder`,
                { settingsId, orderedIds },
                { headers: this.headers }
            )
        );
    }

    dutyEngineerCreated$() {
        return this.socketService.receiveMessageObserver(DutyEngineerEvents.DUTY_ENGINEER_CREATED);
    }

    dutyEngineerUpdated$() {
        return this.socketService.receiveMessageObserver(DutyEngineerEvents.DUTY_ENGINEER_UPDATED);
    }

    dutyEngineerDeleted$() {
        return this.socketService.receiveMessageObserver(DutyEngineerEvents.DUTY_ENGINEER_DELETED);
    }

    dutyEngineerReordered$() {
        return this.socketService.receiveMessageObserver(DutyEngineerEvents.DUTY_ENGINEER_REORDERED);
    }
}
